import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SLA_COLORS } from "./palette";

const hours = (min: number) => (min % 60 === 0 ? `${min / 60} h` : `${Math.floor(min / 60)} h ${min % 60} min`);
const ratio = (v: number, total: number) => (total > 0 ? Math.min(1, Math.max(0, v / total)) : 0);
const pct = (v: number, total: number) => `${Math.round(ratio(v, total) * 1000) / 10}%`;
// Rótulo ancorado num ponto do eixo: centralizado, mas sem vazar pelas bordas.
const anchor = (r: number) => (r >= 0.9 ? "translateX(-100%)" : r <= 0.1 ? "none" : "translateX(-50%)");
// Distância mínima (fração do eixo) entre "agora" e "meta" para dividirem a mesma linha.
const MIN_LABEL_GAP = 0.15;

export type SlaBarProps = { elapsedMin: number; challengeMin: number; targetMin: number };

// Barra de SLA em CSS puro (sem recharts): verde até o challenge, âmbar até a meta, vermelho além dela.
export default function SlaBar({ elapsedMin, challengeMin, targetMin }: SlaBarProps) {
  const total = Math.max(elapsedMin, targetMin);
  const green = Math.min(elapsedMin, challengeMin);
  const amber = Math.max(0, Math.min(elapsedMin, targetMin) - challengeMin);
  const red = Math.max(0, elapsedMin - targetMin);
  const nowRatio = ratio(elapsedMin, total);
  const nowOnSecondRow = Math.abs(nowRatio - ratio(targetMin, total)) < MIN_LABEL_GAP;
  const label = `${hours(elapsedMin)} na etapa; meta ${hours(targetMin)}, meta desafio ${hours(challengeMin)}`;
  return (
    <Box>
      <Box role="img" aria-label={label} sx={{ display: "flex", height: "8px", borderRadius: "4px", overflow: "hidden", bgcolor: "#eef2f6" }}>
        <Box data-testid="sla-seg-green" sx={{ width: pct(green, total), bgcolor: SLA_COLORS.green }} />
        {amber > 0 && <Box data-testid="sla-seg-amber" sx={{ width: pct(amber, total), bgcolor: SLA_COLORS.amber }} />}
        {red > 0 && <Box data-testid="sla-seg-red" sx={{ width: pct(red, total), bgcolor: SLA_COLORS.red }} />}
      </Box>
      <Box sx={{ position: "relative", height: nowOnSecondRow ? "36px" : "18px", mt: 0.5 }}>
        <Typography variant="caption" color="text.secondary" sx={{ position: "absolute", top: 0, left: pct(challengeMin, total), transform: anchor(ratio(challengeMin, total)) }}>
          meta desafio {hours(challengeMin)}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ position: "absolute", top: 0, left: pct(targetMin, total), transform: anchor(ratio(targetMin, total)) }}>
          meta {hours(targetMin)}
        </Typography>
        <Typography
          data-testid="sla-now"
          data-row={nowOnSecondRow ? 2 : 1}
          variant="caption"
          color="text.secondary"
          sx={{ position: "absolute", top: nowOnSecondRow ? "18px" : 0, left: pct(elapsedMin, total), transform: anchor(nowRatio) }}
        >
          agora
        </Typography>
      </Box>
    </Box>
  );
}
